module.exports = __webpack_public_path__ + "static/media/20231026-DSC_4870.9191b62c.jpg";